module.exports = "import {Button, Fab, Snackbar} from 'preact-material-components';\n"